const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';

/**
 * A PocketBase record id (15 × [a-z0-9]) made on the device. Creating with
 * it makes a create safe to repeat: a queued change that went out just
 * before the app was closed is sent again on the next start.
 */
export function newRecordId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(15));
  return Array.from(bytes, (b) => ALPHABET[b % ALPHABET.length]).join('');
}
